<div class="w-full h-full md:p-12 p-5 overflow-y-scroll hide-bar" *transloco="let t">

  <div class="w-[250px] ml-auto">
    <std-select (onChangeValue)="getReminders($event)" [data]="mySalons" [label]="t('selectSalon')" bindValue="id"
      bindLabel="name" [placeholder]="t('selectSalon')" customLabel="label-input"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
      customClassContaier="custom-select"></std-select>
  </div>

  <div class="my-4 items-center gap-8">
    <div class="rounded-xl">
      <div class="md:max-w-[calc(100vw-317px)] md:overflow-x-scroll custom-scroll mb-4"> <std-table
          class="hide-bar-all bg-secondary  fix-table" [data]="dataTable" tableContainerClass="bg-secondary "
          headerClass=" bg-primary focus:bg-primary hover:bg-primary">
          <span stdoutTableColumn width="110" [label]="t('firstName')" property="firstName"></span>
          <span stdoutTableColumn width="110" [label]="t('lastName')" property="lastName"></span>
          <span stdoutTableColumn width="110" [label]="t('email')" property="email"></span>
          <span stdoutTableColumn width="110" [label]="t('service')" property="itemName"></span>
          <span stdoutTableColumn width="110" [label]="t('expirationDate')" property="expirationDate"></span>

          <span stdoutTableColumn width="110" [label]="t('actions')">
            <ng-template #dataTableCell let-item="item">
              <div class="flex items-end gap-5">
                <std-button (click)="sendReminderWhatapp(item)" size="xs" type="primary"
                  buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto">
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.68579 13.305C1.68579 11.3024 2.13714 9.70237 3.02702 8.54587C4.10163 7.14963 5.79887 6.39634 8.07687 6.30319V3.07593L14.6886 8.70215L8.07687 14.3284V11.1199C6.69376 11.1571 5.64947 11.3568 4.81772 11.74C3.91909 12.1542 3.26739 12.773 2.56473 13.5748L1.68579 14.5784V13.305Z" fill="white"/>
                    </svg>
                    
                </std-button>
              </div>
            </ng-template></span>

        </std-table>
      </div>
    </div>
  </div>